import * as types from './actionTypes';
import initialState from './initialState';

const featuresReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_FEATURES_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_FEATURES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: action.payload.features,
        },
      };
    case types.GET_FEATURES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};

export default featuresReducer;
